var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ModalRoot"},_vm._l((_vm.modals.open),function(m){return _c(m.component,_vm._b({key:m.modalId,tag:"component",on:{"close":function($event){return _vm.closeModal(m)},"reopenModal":function($event){return _vm.reopenModal(m, $event)}}},'component',m.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }